module.exports = require('./src/index.js');
